import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import { shouldShowLpnSurvey } from 'tio-employee/utils/tas/lpn-survey';
import type Transition from '@ember/routing/transition';
import type RouterService from '@ember/routing/router-service';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';

export default class AuthenticatedTasConfirmationRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;

  includes = ['tas-courses', 'tas-program-instance.tas-program-template'];

  beforeModel(transition: Transition) {
    if (transition.to?.queryParams.tasType === undefined) {
      this.router.transitionTo('authenticated.tas.dashboard');
    }
  }
  async model(params: { tasType: string; applicationId: string; evidence: boolean }) {
    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', params.applicationId, {
        include: this.includes.join(','),
      })
    )) as { content: { data: TasApplicationModel } };
    const application = content.data;
    // Shared with the manage screen's submitted modal (utils/tas/lpn-survey), which
    // is where the guided flow now lands — the two must ask the same employees.
    const showLpnSurvey = await shouldShowLpnSurvey(application, {
      store: this.store,
      sessionContext: this.sessionContext,
    });
    return { application, tasType: params.tasType, evidence: params.evidence, showLpnSurvey };
  }
}
